import React, {useEffect} from 'react';

import * as Sentry from '@sentry/browser';
import springboard from 'springboard';
import {useCurrentUser} from '@/modules/music_sniper/hooks/useCurrentUser';

if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        tunnel: `https://private-beta.songdrive.app/api/s`,
        environment: process.env.SENTRY_ENV,
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            Sentry.replayIntegration(),
        ],
    });

    springboard.registerModule('Sentry', {}, async (moduleAPI) => {
        return {
            Provider: (props: React.PropsWithChildren) => {
                const currentUser = useCurrentUser();

                useEffect(() => {
                    if (currentUser) {
                        Sentry.setUser({id: currentUser.id, username: currentUser.name});
                    }
                }, [currentUser]);

                return props.children;
            }
        }
    });
}
